export const environment = {
  production: true,

  clientId: 'Pbnx2tngdyjw4mpxusbqx7e7',
  xApiVersion: '1.0',

  //#region Authentication endpoints
  apiRoot: 'https://aryzatimeprod.azurewebsites.net',
  portalRoot: 'https://creditors.accountants',
  //#endregion

  updateInterval: 60 /* minutes. Interval at which the app checks for updates */,

  hasPdf: false, // whether PDF generation is enabled.  Currently does not work on Azure.

  hasCapacity: true, // whether Capacity Settings and Time Review Capacity are visible

  hasProvision: true, // whether Time Review Capacity is available

  jobSelectInactiveJobToggle: false, // whether to show include inactive jobs toggle in job select, or always show all jobs

  sendToSentry: true, // whether to send error and transcation data to Sentyr

  traceSampleRate: 1, //what percent (0-1) of transactions to send to Sentry

  replaysSessionSampleRate: 0.1, //what percent (0-1) of transactions to send to Sentry

  replaysOnErrorSampleRate: 1.0, //what percent (0-1) of transactions to send to Sentry

  hasTasking: false, // tasking navigation item

  hasAiTelemtery: true, // whether to send application insights telemetry information to Azure

  aiInstrumentationKey: '16bb4e08-a5a8-4aed-bc7f-9f308994ac3c',

  aiIngestionEndpoint: 'https://uksouth-1.in.applicationinsights.azure.com',

  aiLiveEndpoint: 'https://uksouth.livediagnostics.monitor.azure.com/',

  aiConnStr:
    'InstrumentationKey={aiInstrumentationKey};IngestionEndpoint={aiIngestionEndpoint};LiveEndpoint={aiLiveEndpoint}',

  includeSandboxRoute: false, // include the route to the sandbox, without necessarily including the nav item

  agGridLicenseKey:
    'Using_this_{AG_Grid}_Enterprise_key_{AG-064899}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Aryza_Australia}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{insol6.app}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{insol6.app}_need_to_be_licensed___{insol6.app}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{8_October_2025}____[v3]_[01]_MTc1OTg3ODAwMDAwMA==ffd7d3616b9d859c3135bc0f9015bda0',

  includeRegionVariantMenu: false, // whether to include the region variant menu in the header

  defaultRegionVariant: 'UK',

  aryzaSSOEnabled: true,
  aryzaAuthUrl: 'https://auth.aryza-integrations.com',
  aryzaClientId: '',

  theme: 'theme-aryza-insolv2-uk-theme', // active Fuse color scheme id, e.g. 'theme-default', 'theme-aryza-insolv2-uk-theme'
  
  appName: 'Aryza Time',
  welcomeTitle: 'Aryza Time',
};
